import { render, staticRenderFns } from "./NFsFluxo.vue?vue&type=template&id=11222bea&scoped=true"
import script from "./NFsFluxo.vue?vue&type=script&lang=js"
export * from "./NFsFluxo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11222bea",
  null
  
)

export default component.exports